var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{style:(_vm.calculateStyle),attrs:{"src":_vm.calculatedSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }